// frontend/src/components/ErrorBoundary.js

import React from 'react';
import { Typography, Container } from '@mui/material';
import i18n from '../i18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so next render shows fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <Typography variant="h4" color="error" align="center" style={{ marginTop: '2rem' }}>
            {i18n.t('common.errorFallback')}
          </Typography>
        </Container>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
